import React from 'react';
import {
    Box
} from '@chakra-ui/react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { useAuth } from '../utils/auth/newAuth';
import SignUpComponent from '../components/Auth/Signup/SignupModal2';


const SignupPage = () => {

    const { user, loading, profile } = useAuth();
    const router = useRouter();

    // Necessary for magic sign in to work
    if (profile) {
        router.push('/listings')
    }

    return (
        <>
            <Head>
                <title key="title">Signup - Zonado</title>
                <link rel="canonical" href="https://zonado.com/signup" />
            </Head>

            <Box
                margin="auto 0"
            >
                <SignUpComponent 
                    email={router.query.email}
                    GoogleAuth={router.query.auth == 'google' ? true : false}
                />
            </Box>

        </>
    );
}

export default SignupPage;